import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1400px] flex-col items-start justify-center px-4 py-24 lg:px-8">
      <div className="font-heading text-7xl font-black text-[#FF5500]">404</div>
      <h1 className="font-heading mt-4 text-3xl font-bold text-white">Página não encontrada</h1>
      <p className="mt-3 text-[#A1A1AA]">A página que você procura não existe ou foi movida.</p>
      <Link to="/" className="mt-8"><Button className="rounded-none bg-[#FF5500] px-8 py-6 font-bold hover:bg-[#CC4400]">Voltar ao início</Button></Link>
    </div>
  );
}
